import { cn } from "~/common/cn"

export type ScreenLoadingProps = {
  label?: string
  delayMs?: number
  className?: string
}

export const ScreenLoading = ({
  label = "Loading...",
  delayMs = 1000,
  className,
}: ScreenLoadingProps) => (
  <div
    className={cn("animate-fade-in p-8 text-center opacity-0", className)}
    style={{ animationDelay: `${delayMs}ms` }}
  >
    {label}
  </div>
)
